import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Posters.scss";

const Posters = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const posters = useSelector((state) => state?.user.menu?.restaurantBanner);
  //const posters = useState(menuList?.restaurantBanner || null);
  // ⏱️ Auto-play slider every 4 seconds
  useEffect(() => {
    if (!posters || posters?.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % posters.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [posters]);

  if (!posters || posters.length === 0) return null;

  return (
    <div className="poster-slider-container">
      <div
        className="poster-slider-wrapper"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {posters.map((url, index) => (
          <div className="poster-slide" key={index}>
            <img src={url.bannerImage} alt={`Promo Banner ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* 🟢 Dots Indicator (Sirf tabhi dikhega jab 1 se zyada poster ho) */}
      {posters.length > 1 && (
        <div className="poster-dots">
          {posters.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Posters;
